import { Toaster as Sonner } from 'sonner';
import { useTheme } from '@/app/theme';

export { toast } from 'sonner';

export function Toaster() {
  const { theme } = useTheme();
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      toastOptions={{ className: 'font-ui !rounded-md !border-line' }}
    />
  );
}
